<template functional>
  <div>
    <span
      class="green cursor-pointer hover:text-green-800"
      :data-action="'showReceivable'"
      :data-order-id="props.item.id"
    >
      {{ props.item.charges.receivable | toCurrency }}
    </span>
  </div>
</template>

<script>
export default {
  name: "fltl-ar",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
